import styled from 'styled-components'
import { css } from 'styled-components'

interface CheckProps {
  checked?: boolean
}

interface DisabledProps {
  disabled?: boolean
}

export const Container = styled.div`
  padding: 1rem 1.5rem;
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 10px;
  max-width: 870px;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
`

export const UnavailableContainer = styled.div`
  padding: 1rem 1.5rem;
  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 10px;
  max-width: 870px;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => `rgb(${theme.background.low})`};
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
`

export const ModuleContent = styled.div`
  h3 {
    margin-top: 0;
    margin-bottom: 9px;
  }

  @media only screen and (min-width: 700px) {
    display: flex;
    align-items: center;
  }
`

export const ModuleUnvailableContent = styled.div`
  h3 {
    margin-top: 0;
  }

  background-color: ${({ theme }) => `rgb(${theme.background.low})`};

  @media only screen and (min-width: 700px) {
    display: flex;
    align-items: center;
  }
`

export const ConcludedLesson = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;

  svg {
    margin-right: 1rem;
  }

  @media only screen and (max-width: 700px) {
    button {
      display: none;
    }
  }

  @media only screen and (min-width: 700px) {
    svg {
      margin-left: 16.5%;
    }
  }

  p {
    margin-top: 0rem;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 1.5rem;

  @media only screen and (min-width: 700px) {
    display: none;
  }
`

export const Expand = styled.button`
  display: flex;
  align-items: center;

  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};

  background: none;
  border: none;

  svg {
    margin-left: 0.4rem;
  }
`

export const StartModule = styled.button<DisabledProps>`
  display: flex;
  align-items: center;

  border: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  border-radius: 4px;

  color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;

  padding: 8px 16px;

  background: none;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: #a7a7a7;
      border-color: #a7a7a7;
    `}

  svg {
    margin-left: 0.4rem;
    margin-right: 0rem;
  }
`

export const MessageModule = styled.button<DisabledProps>`
  display: flex;
  align-items: center;

  border: 1px solid #0bc196;
  border-radius: 4px;

  color: #0bc196;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;

  padding: 8px 16px;

  background: none;

  margin-left: 1rem;

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: #a7a7a7;
      border-color: #a7a7a7;
    `}

  svg {
    margin-left: 0.4rem;
    margin-right: 0rem;
  }
`

export const BuyModule = styled.a`
  display: flex;
  align-items: center;

  background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 4px;
  border: none;

  color: ${({ theme }) => `rgb(${theme.background.high})`};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;

  padding: 8px 16px;

  svg {
    margin-right: 0.4rem;
  }

  &:hover {
    color: ${({ theme }) => `rgb(${theme.background.high})`};
  }
`

export const LessonsWrapper = styled.div`
  background: ${({ theme }) => `rgba(${theme.background.high}, 0.5)`};
  width: calc(100% + 3rem);
  margin: 1rem -1.5rem -1rem;
  padding: 1rem 14%;
  max-height: 450px;
  overflow-y: auto;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
`

export const Lesson = styled.div<DisabledProps>`
  border-bottom: 1px solid ${({ theme }) => `rgb(${theme.component.accent})`};
  ${({ disabled }) =>
    !disabled &&
    `
      color: #868686;
  `}

  &:last-child {
    border: none;
  }

  padding-bottom: 2rem;
  cursor: pointer;

  h3 {
    font-weight: 700;
    line-height: 1.75rem;
    font-size: 1rem;

    margin-bottom: 9px;
  }

  .card-wrapper {
    margin-top: 22px;
  }

  div {
    display: flex;
    align-items: center;

    span {
      font-weight: 700;
      line-height: 1.125rem;
      font-size: 0.875rem;
      color: ${({ theme }) => `rgb(${theme.greenProgress.base})`};
    }
  }
`

export const CheckLesson = styled.div<CheckProps>`
  min-width: 18px;
  min-height: 18px;
  max-width: 18px;
  max-height: 18px;
  border-radius: 50%;
  margin-right: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${(props) => (props.checked ? `rgb(${props.theme.greenProgress.base})` : '#fff')};
  border: 1px solid
    ${(props) => (props.checked ? `rgb(${props.theme.greenProgress.base})` : '#a7a7a7')};

  svg {
    color: #fff;
  }
`

export const ProgressbarWrapper = styled.div`
  @media only screen and (min-width: 700px) {
    display: none;
  }
`

export const ProgressCircleWrapper = styled.div`
  @media only screen and (max-width: 700px) {
    display: none;
  }
`

export const ExpandDesktop = styled.button`
  display: flex;
  align-items: center;

  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  background: none;
  border: none;
  margin: 0 0 0 auto;

  @media only screen and (max-width: 700px) {
    display: none;
  }
`

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  h2 {
    font-size: 14px;
    margin: 0;
    margin-top: 1.5rem;
  }
  @media only screen and (min-width: 1100px) {
    h2 {
      margin-bottom: 0.5rem;
    }
  }
  @media only screen and (min-width: 1400px) {
    h2 {
      margin-bottom: -3%;
    }
  }
`

export const BuildingStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 152px;
  height: 37px;
  color: #ffffff;
  margin-left: 1rem;
  text-align: center;
  background: ${({ theme }) => (theme.isDark ? '#393939' : ' #c6c6c6')};
  border-radius: 100px;
`

export const TimeIcons = styled.div`
  color: ${({ theme }) => (theme.isDark ? '#CFCFCF' : ' #393939')};
  font-size: 10px;
  font-style: normal;
  font-weight: 600;

  display: flex;
  gap: 16px;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
`
